import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BedModel} from '../model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function getBedByIdService(id: string | undefined | number) {
  return await axios.get<ResponseObject<BedModel>>(`${BASEURL}/bed/getBedById`, {
    params: {
      Id: id,
    },
  })
}
